import { base, element } from "../reset/reset.css.mjs";
import { sprinkles } from "./sprinkles.css.mjs";
const atoms = ({ reset, ...rest }) => {
  if (!reset) {
    return sprinkles(rest);
  }
  const elementReset = element[reset];
  const sprinklesClasses = sprinkles(rest);
  return `${base}${elementReset ? ` ${elementReset}` : ""}${sprinklesClasses ? ` ${sprinklesClasses}` : ""}`;
};
export {
  atoms
};
